import api from '@/apis/shareReportConfig/organizationShareFormulaAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('OrganizationShareFormula', api);

const state = {
  ...crud.state,
  _config: {
    table: 'organization_share_formula',
    field: {
      key: 'organization_share_formula_id',
      code: 'organization_code',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
